import { render, staticRenderFns } from "./AdminSysType.vue?vue&type=template&id=28076191&scoped=true"
import script from "./AdminSysType.vue?vue&type=script&lang=js"
export * from "./AdminSysType.vue?vue&type=script&lang=js"
import style0 from "./AdminSysType.vue?vue&type=style&index=0&id=28076191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28076191",
  null
  
)

export default component.exports